export default class ReviewsFinalRatingStatus {
    static get Increased () { return 'increased' }
    static get Decreased () { return 'decreased' }
    static get NotChanged () { return 'not_changed' }
}
